export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更預告_sc-345be5366bb99de8efa64d0c1d87cad5.png";